/* eslint-disable camelcase */
import React from 'react'
import ChipRectangle from 'components/ChipRectangle'

const MINIS = 'Minis'

/**
 * @param {ProductBadgesProps} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function ProductBadgeMinis (props) {
  const {
    isSetWithMinis
  } = props

  if (!isSetWithMinis) {
    return <></>
  }

  return (
    <ChipRectangle>
      {MINIS}
    </ChipRectangle>
  )
}
